export default "__VITE_ASSET__6BBOWMia__"